commonModule.factory('usageEventsService', ['$http','AppSettings', '$q',
    function ($http, AppSettings, $q) {
    var usageEventsService = {};

    usageEventsService.Categories = function() {
        return ({
            contract: 'contract',
            transaction: 'transaction',
            quote: 'quote',
            rate: 'rate',
        });
    }

    usageEventsService.send = function(opts) {
        window.usageEvents('send', opts);
    }

    usageEventsService.userChanges = function(user) {
        if (user) {
            window.usageEvents('identify', {userId: user.Id, providerId: user.PrimaryProviderId});
            return;
        }
        window.usageEvents('identify', {userId: null});        
    }

    usageEventsService.dealerChanges = function(id) {
        window.usageEvents('identify', { dealershipId: id || null });
    }

    usageEventsService.contractCreated = function(count) {
        usageEventsService.send({category: usageEventsService.Categories().contract, action: 'create', label: 'count', value: count});
    }

    usageEventsService.quoteSaved = function(sessionid, count) {
        usageEventsService.send({category: usageEventsService.Categories().quote, action: 'create', label: sessionid, value: count});
    }
    
    usageEventsService.ratesRetrieved = function(sessionid, productCode) {
        usageEventsService.send({category: usageEventsService.Categories().rate, action: 'retrieve', label: sessionid + '/' + productCode, value: 1});
    }

    return usageEventsService;
}]);
